import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 10.36L24.52 24H7.48L16 10.36zm0-5.027L2.667 26.667h26.666L16 5.333z" fill="#54585D" /></svg>);